import Icon from '../components/Icon.vue'

Icon.register({
  'mars-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M340 0H261C250.3 0 245 12.9 252.5 20.5L269.4 37.4 220.7 86.1C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208S64.5 352 144 352 288 287.5 288 208C288 179.8 279.9 153.5 265.9 131.3L314.6 82.6 331.5 99.5C333.9 101.9 337 103 339.9 103 346.1 103 352 98.2 352 91V12C352 5.4 346.6 0 340 0zM144 288C99.9 288 64 252.1 64 208S99.9 128 144 128 224 163.9 224 208 188.1 288 144 288zM500 159.9H421C410.3 159.9 405 172.8 412.5 180.4L429.4 197.3 380.7 246C362.5 234.6 341.7 227.1 319.2 224.7 317.1 246.5 311 268 300.8 288 301.9 288 303 287.9 304 287.9 348.1 287.9 384 323.8 384 367.9S348.1 447.9 304 447.9 224 412 224 367.9C224 366.8 224 365.7 224.1 364.7 204.1 374.9 182.6 381.1 160.8 383.1 168.4 455.6 229.6 512 304 512 383.5 512 448 447.5 448 368 448 339.8 439.9 313.5 425.9 291.3L474.6 242.6 491.5 259.5C493.9 261.9 496.9 263 499.9 263 506.1 263 512 258.2 512 251V172C512 165.3 506.6 159.9 500 159.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars-double.js
// module id = iY6I
// module chunks = 144